// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"12974":"skin-copy","50169":"aria-labels"}[chunkId] || chunkId) + "-" + {"12974":"a1141c9cbfaf1eeb5873","34454":"eb8563cf0d2b5409182b","50169":"b50bad80ec589360b430","54740":"ca71d8cfe9381bbefa26","59959":"87e32afdb3aa16528d2e","79690":"526f2cb7bdc9a01fe119"}[chunkId] + ".min.js";
};